import { BetSlipStatus } from "@api-types/agency/bet-slip/BetSlipStatus";
import { BetSlipStatusAbrv } from "@utils/common";

export function shouldShowBetSlipStatus(bet: { betSlipStatus: BetSlipStatus }) {
	return (
		bet.betSlipStatus.abrv.includes(BetSlipStatusAbrv.CASHOUT) ||
		bet.betSlipStatus.abrv === BetSlipStatusAbrv.PAID_OUT
	);
}
